module.exports = __webpack_public_path__ + "static/media/pecuaria-4.d7a29f04.jpg";